export default __webpack_public_path__ + "static/media/Custom-HUD-Artificial Horizon.fcefad80.jpg";